import React, {Component} from "react";
import {connect} from "react-redux";
import styled from "styled-components";
import {withRouter} from "react-router-dom";
import {Heading, Text} from "components/styled";
import {commonLocalization} from "localization";
import {getProjectsStatsSuccess} from "../../../infraMonitor/projects-stats/actions";
import infraMonitorService from "api/infraMonitorService";
import {FiscalYearDropdown} from "components/layouts";

class Header extends Component {
    state = {
        isOpen: false
    };

    onDateToggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    };

    handleDateChange = date => {
        this.setState({
            isOpen: false,
            date
        });
        let {search} = this.props.history.location;
        this.props.dispatchProjectsStats(date);
        this.props.getDataList(date);
        if (!search || search.includes("year"))
            this.props.history.push({search: `?year=${date}`});
        else this.props.history.push({search: search.concat(`&year=${date}`)});
    };

    render() {
        const {selectedLanguage, fiscalYears, location} = this.props;
        const ifAboutOrContact = /contact|about/.test(location.pathname);

        return (
            <HeaderMain lang={selectedLanguage}>
                <div className="header-inner">
                    <Heading.h1 uppercase>
                        {commonLocalization[selectedLanguage].header} -
                    </Heading.h1>
                    <span className="btn-grey">
                        {commonLocalization[selectedLanguage].headerDistrict}
                    </span>

                    {selectedLanguage === "en" && !ifAboutOrContact ? (
                        <Text.span className="fiscal-year-label">for</Text.span>
                    ) : (
                        <span style={{marginLeft: "8px", display: "inline-block"}}/>
                    )}

                    {!ifAboutOrContact &&
                        <FiscalYearDropdown fiscalYears={fiscalYears}/>
                    }
                </div>
            </HeaderMain>
        );
    }
}

const mapStateToProps = state => ({
    totalFiscalYear: state.projectsStatsReducers.data.fiscalyear,
    selectedLanguage: state.localizationReducers.selectedLanguage,
    fiscalyear: state.fiscalYearReducers.selectedFiscalYear,
    fiscalYears: state.staticData.fiscalYears
});

const mapDispatchToProps = dispatch => ({
    dispatchProjectsStats: fy => {
        infraMonitorService.getProjectsStats(fy).then(response => {
            dispatch(getProjectsStatsSuccess(response));
        });
    }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Header));

const HeaderMain = styled.div`
  margin-bottom: 32px;
  .btn-grey {
    color: var(--color-theme-1);
    font-size: ${props => (props.lang === "en" ? "17px" : "22px")};
    opacity: 0.7;
    padding: ${props =>
      props.lang === "en" ? "4px 12px 4px 10px" : "4px 12px 4px 10px"};
    text-transform: none;
    &:after {
      display: none;
    }
  }

  .header-inner {
    line-height: ${props => (props.lang === "en" ? "28px" : "32px")};
    
    > h1,
    > span,
    > div {
      vertical-align: middle;
    }
  }

  h1 {
    display: inline;
    font-size: ${props => (props.lang === "en" ? "17px" : "22px")};
    opacity: 0.4;
  }

  .fiscal-year-label {
    color: var(--color-theme-1);
    opacity: 0.4;
    margin: 0 12px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/header/header.js